import eventBus, { eventType } from '@g/utils/eventBus'
import calc from 'calculatorjs'
import * as storageUtils from '@g/utils/storageUtils'
import { HAS_PACK_FOOD_STORAGE_KEY } from '@g/order-shared/storage/constants'
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib'
import download from 'downloadjs'
import dayjs from 'dayjs'
import { isInApp, actOpenSysBrowser } from './appSDK'
import { upyun, ccmss3 } from '@g/filters/index'

export function computerParcelFee (weight, fee, minWeight = 0) {
  weight = Math.max(weight, minWeight)
  weight = weight / 1000

  const weightSplit = weight.toFixed(3).split('.')
  if (weightSplit[1] && Number(weightSplit[1]) >= 100) {
    weight = Math.ceil(weight)
  } else {
    weight = Math.floor(weight)
  }
  return calc(`${weight}*${fee}`)
}

export function computeFeeBySrItemAndWeight ({ srItem, weight, isCeil = true, discount = 1 }) {
  const settlementWeight = computerSettlementWeight(weight, srItem.minWeight, isCeil, srItem.transport)
  let r = 0
  if (srItem.firstWeight > 0 && srItem.addlWeight > 0) {
    if (settlementWeight > 1000) {
      r = calc(
        `${calc.mul(1, srItem.fwFee)}+${calc.mul(
          settlementWeight / 1000 - 1,
          srItem.awFee
        )}`
      )
    } else {
      r = calc.mul(settlementWeight / 1000, srItem.fwFee)
      // return computerParcelFee(settlementWeight, srItem.fwFee)
    }
  } else {
    r = calc.mul(settlementWeight / 1000, srItem.fwFee)
    // return computerParcelFee(settlementWeight, srItem.fwFee)
  }
  return parseInt(calc.mul(r, discount))
}

/**
 * 結算重量
 * @param {*} weight
 * @param {*} minWeight
 */
export function computerSettlementWeight (weight, minWeight = 0, isCeil = true, transport) {
  weight = Math.max(weight, minWeight, 1000)
  if (!isCeil || transport === 'sea') {
    weight = weight / 1000 // 不取整，按實際重量收費
  } else if (transport === 'air' && weight % 1000 >= 100) {
    weight = parseInt(weight / 1000) + 1
  } else if (weight % 1000 > 500) { // 0.5 进位
    weight = parseInt(weight / 1000) + 1
  } else if (weight % 1000 >= 100) {
    weight = calc.add(parseInt(weight / 1000), 0.5)
  } else { // 小于 100g 舍去
    weight = parseInt(weight / 1000)
  }
  return calc(`${weight}*1000`)
}

/**
 * 判斷訂單是否能取消
 * @param {*} item
 */
export function enabledClose (order) {
  // if (order.jyoPayStatus === '9' && order.jyoStatus === '0') {
  //   return window.vueApp.countdownData.currTime < order.canCancelTime && order.jyoStatusBrief !== 'DELAY0'
  // }

  return ['1', '9'].includes(order.jyoPayStatus) && ['0', '31', '4'].includes(order.jyoStatus) && order.jyoStatusBrief !== 'DELAY0'
}

/**
 * 關閉訂單
 */
export async function close (item) {
  if (['1', '2'].includes(item.jyoStatus)) {
    if (window.vueApp.$toast) {
      window.vueApp.$toast('訂單已開始處理，不可取消')
    } else {
      window.vueApp.$confirm('訂單已開始處理，不可取消', { buttonFalseText: '' })
    }
    return false
  }
  let confirmText = '請確認您要取消訂單嗎？'
  if (item.jyoPayBrief?.startsWith('CREDITDG')) {
    confirmText = '請確認您要取消訂單！訂單取消後M幣會退回！'
  } else if (item.jyoPayBrief?.startsWith('LGID')) {
    confirmText = '請確認您要取消訂單！訂單取消後T幣會退回！'
  }
  if (!await window.vueApp.$confirm(confirmText)) return false

  let resPromise
  if (item.isMessy) {
    resPromise = window.vueApp.$store.dispatch('jyo/jyorder/refundMessy', {
      messyid: item.jyoExtraInfo.messyParcels.messyid,
    })
  } else if (item.oidbat) {
    resPromise = window.vueApp.$store.dispatch('jyo/jyorderBat/refundByOidbat', {
      oidbat: item.oidbat,
    })
  } else {
    resPromise = window.vueApp.$store.dispatch('jyo/jyorder/refund', { oid: item.oid })
  }
  return resPromise.then(res => {
    if (window.isPc) {
      window.vueApp.$store.dispatch('parcel/fetchDashboardList', {
        pageSize: 500,
        jyAddrid: window.vueApp.$store.state.userData.defaultWhsAddrid
      })
      eventBus.$emit(eventType.ReloadParcelOrder)
    }
    if (item.parcels) {
      if (item.parcels.find(parcel => {
        return parcel.extraInfo.tpTaobaoTradeItems && parcel.extraInfo.tpTaobaoTradeItems.find(tpItem => tpItem.itemMold === '2')
      })) {
        storageUtils.remove(HAS_PACK_FOOD_STORAGE_KEY)
      }
    }

    return res
  })
}

export function machineOrder (order) {
  function parseParcels (order, subtno) {
    const pclids = subtno.stPclids.split(',').filter(a => a)
    return pclids.map(pclid => {
      return order.parcels.find(item => item.pclid === pclid)
    })
  }
  const machineOrderData = {
    ...order,
    subtnos: (order.subtnos || []).map(subtno => {
      return {
        ...subtno,
        parcels: parseParcels(order, subtno)
      }
    })
  }
  return {
    ...machineOrderData,
    ...computeSeaPreApntdState(machineOrderData)
  }
}

export function computeSeaPreApntdState (order) {
// 付款未满 60 分钟时，不显示“收不到預先委任通知”按钮
// 超过 60 分钟且仍未确认相符时，才显示按钮
// 点击后显示 EZWay 预先委任教学图
// 如果預估有多件，倉庫打包後有單號了再顯示區域

  // 23:00~9:00 期间点击按钮“我已確認相符”立即标记为已申报，并隐藏預先委任區域。

  const preHawbs = order.jyoExtraInfo?.preHawbs || {}
  const estimateSubtnos = Number(order.jyoExtraInfo?.parcelsInfo?.estimateSubtnos?.length || 0)
  // 预估会拆成多个分提单时，必须等到实际分提单产生后才显示预先委任提示。
  const needSeaPreApntdSubtnoReady = estimateSubtnos > 1
  // 正式报关需先完成报单预审确认，才显示预先委任。
  const needSeaPreApntdCcDeclConfirmed = String(order.jyoShpMethod) === '91'
  const isCompany = Number(order.jyoTradevanAddress?.isCompany || 0) === 1
  const seaPreApntdSubtnoReady = !needSeaPreApntdSubtnoReady || (Array.isArray(order.subtnos) && order.subtnos.length > 0)
  const seaPreApntdCcDeclConfirmed = !needSeaPreApntdCcDeclConfirmed || (
    Array.isArray(order.jyoExtraInfo?.ccDeclFiles) &&
    order.jyoExtraInfo.ccDeclFiles.length > 0 &&
    Array.isArray(order.jyoExtraInfo?.ccDeclFilesCfm) &&
    order.jyoExtraInfo.ccDeclFilesCfm[0] === 'ok'
  )
  // 这里只判断订单本身是否处于“海快待预先委任”状态，不包含本地夜间隐藏等 UI 态。
  const isSeaPreApntdPending =
    order.jyoSrTransport === 'se' &&
    String(order.jyoPayStatus) === '9' &&
    !preHawbs.tvPreApntdReplyTime &&
    seaPreApntdCcDeclConfirmed &&
    !isCompany
  const showSeaCheckPreApntd = isSeaPreApntdPending && seaPreApntdSubtnoReady
  return {
    // 订单是否处于海快待预先委任状态。
    isSeaPreApntdPending,
    // 是否需要等待实际分提单生成后才能显示。
    needSeaPreApntdSubtnoReady,
    // 当前是否已满足分提单显示前置条件。
    seaPreApntdSubtnoReady,
    // 页面是否应显示海快预先委任组件。
    showSeaCheckPreApntd,
  }
}

export function getShareData (order, stTrackingNo) {
  const subtno = order.subtnos.find(item => item.stTrackingNo === stTrackingNo)
  return {
    title: `「${order.jyoCneeAddress.consignee.replace(/^.+(.)$/, '**$1')}」包裹${order.jyoStatusName}，共 ${subtno.stPclids.split(',').length} 件。`,
    url: `kkren.com.tw/st/${order.oid}.${subtno.stTrackingNoRaw || subtno.stTrackingNo}`
  }
}

export async function checkPayDelayOrder () {
  const userData = window.vueApp.$store.state.userData
  console.log('checkPayDelayOrder', userData.vaordersPayDelay)
  if (userData.vaordersPayDelay && userData.vaordersPayDelay.length && userData.vaordersPayDelay.filter(item => item.vaType === 'du').length > 1) {
    const duOrder = userData.vaordersPayDelay.filter(item => item.vaType === 'du')[0]
    if (await window.vueApp.$confirm('貼心提醒～您有集運訂單需支付稅金，目前尚未完成付款，請先付款後再繼續其他操作。', {
      title: `${duOrder.vaTypeName}付款`,
      icon: false,
      color: 'blue',
      buttonFalseText: '稍後再說',
      buttonTrueText: '現在去支付',
      theme: 'czc',
    })) {
      if (window.isPc) {
        window.vueApp.$eventBus.$emit(window.vueApp.$eventType.ViewVaorderDuListUnpay)
      } else {
        window.vueApp.$router.push({ name: 'KkrenVaorderDuListUnpay' })
      }
    }
    return false
  }
  const vaorderPayDelay = userData.vaordersPayDelay?.[0]

  if (vaorderPayDelay &&
    (vaorderPayDelay.vaType === 'tp' ||
    vaorderPayDelay.vaType === 'ip' ||
    vaorderPayDelay.vaType === 'bx' ||
     (!window.isPc && vaorderPayDelay.vaType === 'fx'))
  ) {
    window.vueApp.$eventBus.$emit(window.vueApp.$eventType.CheckPayDelayOrder)
    return false
  } else if (vaorderPayDelay && vaorderPayDelay.vaOid) {
    const date = window.vueApp.$dayjs(vaorderPayDelay.createdTime * 1000).format('YYYY年M月D日')
    if (await window.vueApp.$confirm(`您在${date}有一筆訂單含有【${vaorderPayDelay.vaTypeName}】尚未付款，需要付款後才能繼續其他操作`, {
      title: `${vaorderPayDelay.vaTypeName}付款`,
      icon: false,
      color: 'blue',
      buttonFalseText: '稍後再說',
      buttonTrueText: '現在去支付',
      theme: 'czc',
    })) {
      if (window.isPc) {
        window.vueApp.$store.commit('jyo/vaorder/setShowVaorderOrderDialogData', {
          vaOid: vaorderPayDelay.vaOid,
          referer: 'vaorderPayDelay',
          // showPay: '1'
        })
      } else {
        window.vueApp.$router.push({
          name: 'KkrenOrderVaorderDetail',
          query: {
            vaOid: vaorderPayDelay.vaOid,
            referer: 'vaorderPayDelay',
            // showPay: '1'
          }
        })
      }
    }
    return false
  } else if (userData.jyorderTaxesCcf && userData.jyorderTaxesCcf.find(order => order.needCcWrs)) {
    const order = userData.jyorderTaxesCcf.find(order => order.needCcWrs)
    const date = window.vueApp.$dayjs(order.createdTime * 1000).format('YYYY年M月D日')
    if (await window.vueApp.$confirm(`您在${date}有一筆訂單${order.oid}需要提供委任書，需要完成繳交後才能繼續其他操作。`, {
      title: '委任書繳交通知',
      icon: false,
      color: 'blue',
      buttonFalseText: '稍後再說',
      buttonTrueText: '前往繳交',
    })) {
      if (window.isPc) {
        window.vueApp.$store.commit('order/setShowOrderDialogData', {
          oid: order.oid,
          referer: 'jyorderWrsDelay',
          // showPay: '1'
        })
      } else {
        window.vueApp.$router.push({
          name: 'KkrenOrderDetail',
          query: {
            oid: order.oid,
            referer: 'jyorderWrsDelay',
            // showPay: '1'
          }
        })
      }
    }
    return false
  }
  return true
}

/**
 * 优先使用的物流偏好
 * @returns
 */
export function computeFirstCarrier ({ jyoChgWeight, parcels, jyoCneeAddress, isLandAddr, isBusiness, jyoSrTransport, csType, jyAddrid }) {
  if (csType === 'cvs') {
    return '711'
  }
  if ((jyAddrid !== '1591') && jyoSrTransport === 'se') {
    return 'hct'
  }
  // 优先使用的物流方式
  let isBig = false // 是否大件
  let carrier = ''
  if (jyoChgWeight > 20 * 1000) {
    isBig = true // 打包後重量20kG
  } else if (parcels.find(parcel => {
    return calc(`${parcel.length}+${parcel.width}+${parcel.height}`) > 1500
  })) { // 或者單件尺寸三邊和超過150就行
    isBig = true
  }
  if (jyoCneeAddress && jyoCneeAddress.extraInfo) {
    let carrierLg = {
      air: '',
      se: '',
    }
    if (typeof jyoCneeAddress.extraInfo.carrierLg === 'string') {
      carrierLg.air = jyoCneeAddress.extraInfo.carrierLg
      carrierLg.se = isBig || jyoCneeAddress.extraInfo.carrierSm === 'tcat' || jyoCneeAddress.extraInfo.carrierSm === 'pch' ? jyoCneeAddress.extraInfo.carrierLg : jyoCneeAddress.extraInfo.carrierSm
    } else if (typeof jyoCneeAddress.extraInfo.carrierLg === 'object') {
      carrierLg = jyoCneeAddress.extraInfo.carrierLg
    }
    if (jyoSrTransport === 'se') {
      carrier = carrierLg.se
    } else {
      if (isBig) {
        carrier = jyoCneeAddress.extraInfo.carrierLg ? jyoCneeAddress.extraInfo.carrierLg.air : 'hct'
      } else if (jyoChgWeight < 3000) {
        carrier = jyoCneeAddress.extraInfo.carrierXs || 'bld'
      } else {
        carrier = jyoCneeAddress.extraInfo.carrierSm
      }
    }
  }
  if (carrier === 'ty' && (jyAddrid === '1210' || jyAddrid === '1598' || jyAddrid === '1591' || jyAddrid === '2769')) {
    carrier = 'hct'
  }

  if (carrier === 'ktj' && (jyAddrid === '1210' || jyAddrid === '1598' || jyAddrid === '1591' || jyAddrid === '2769')) {
    carrier = 'hct'
  }
  if (carrier === 'tcat' && (jyAddrid !== '1591' && jyAddrid !== '1024')) {
    carrier = 'hct'
  }

  if (carrier === 'sf') {
    // 去掉順豐
    carrier = 'hct'
  }
  const day = new Date().getDay()
  if (carrier === 'bld' && (day === 4)) {
    carrier = 'tcat'
  }
  if (carrier === 'bld' && isLandAddr) { // 离岛地址便利带改为黑猫
    carrier = 'tcat'
  }
  if (carrier === 'bld' && isBusiness) { // 便利帶稅金是我們自己付的，所以使用黑猫
    carrier = 'tcat'
  }

  return carrier
}

export async function downTaxImgsToPdf (item) {
  const taxImgs = item.taxImgs

  for (let i = 0; i < taxImgs.length; i++) {
    const url = taxImgs[i].indexOf('duties/') === 0 ? ccmss3(taxImgs[i]) : upyun(taxImgs[i])
    window.open(url)
  }

  // const pdfDoc = await PDFDocument.create()

  // const copyPages = async (url) => {
  //   const firstDonorPdfBytes = await fetch(url).then(res => res.arrayBuffer())
  //   const firstDonorPdfDoc = await PDFDocument.load(firstDonorPdfBytes)
  //   // const [firstDonorPage] = await pdfDoc.copyPages(firstDonorPdfDoc, [0])
  //   const pages = await pdfDoc.copyPages(firstDonorPdfDoc, Array.from(new Array(firstDonorPdfDoc.getPageCount()).keys()))
  //   pages.forEach(page => {
  //     pdfDoc.addPage(page)
  //   })
  // }
  // for (let i = 0; i < taxImgs.length; i++) {
  //   const url = taxImgs[i].indexOf('duties/') === 0 ? ccmss3(taxImgs[i]) : upyun(taxImgs[i])
  //   await copyPages(url)
  // }

  // const pdfBytes = await pdfDoc.save()
  // if (isInApp()) {
  //   var file = new Blob([pdfBytes], { type: 'application/pdf' })
  //   window.vueApp.$store.dispatch('upyun/uploadImg', {
  //     file: file,
  //     noLimitName: true,
  //     policyParams: {
  //       dir: 'temp',
  //       ext: 'pdf',
  //     }
  //   }).then(res => {
  //     const url = `https://jyb.upjyb.l-qian.cn${res.data.url}`
  //     actOpenSysBrowser(url)
  //   })
  // } else {
  //   download(pdfBytes, `税票-${item.oid}.pdf`, 'application/pdf')
  // }
}

export async function downDeclFilePdf (item) {
  let files = []
  item.subtnos.forEach(subtno => {
    if (subtno.goodscc && subtno.goodscc.gccExtras && subtno.goodscc.gccExtras.declFile) {
      files.push(subtno.goodscc.gccExtras.declFile)
    } else if (subtno.stExtraInfo && subtno.stExtraInfo.declFile) {
      files.push(subtno.stExtraInfo.declFile)
    }
  })
  files = Array.from(new Set(files))
  for (let i = 0; i < files.length; i++) {
    const url = ccmss3(files[i])
    if (isInApp()) {
      actOpenSysBrowser(url)
    } else {
      window.open(url)
    }
  }
}

export function jyoStatusToName (jyoStatus) {
  return {
    0: '已下單',
    1: '揀貨中',
    2: '打包中',
    3: '已打包',
    31: '預先委任',
    32: '清關資料待確認',
    34: '清關資料已確認',
    4: '取消出貨',
    5: '已出貨',
    9: '已簽收',
  }[jyoStatus]
}

/**
 * 计算打包排序位置
 * 根据仓库地址ID和包裹数量，计算当前订单在打包队列中的位置
 *
 * @param {string} addrid - 仓库地址ID
 * @param {number} qty - 当前订单的包裹数量
 * @returns {Object} 返回包含 total 和 curr 的对象
 *   - total: 该仓库所有待打包订单的总数
 *   - curr: 包裹数量小于等于当前订单的订单总数（即当前订单前面有多少单）
 *
 * 计算逻辑说明：
 * 1. 从 store 中获取按仓库地址分组的未打包包裹数量统计数据
 * 2. total：累加该仓库所有订单的计数器（jyoCounter），得到总订单数
 * 3. curr：只累加包裹数量 <= qty 的订单计数器，得到排在当前订单前面的订单数
 * 4. 用于展示类似 "您的订单排在第 curr 位，前面还有 total 个订单" 的提示信息
 */
export function getPackSort (addrid, qty) {
  // 获取按仓库地址分组的未打包包裹数量数据
  const groupUnpackedParcelQtyData = window.vueApp.$store.state.stats.jyorderStats.groupUnpackedParcelQtyData

  // 初始化返回结果
  const r = {
    total: 0, // 该仓库待打包订单总数
    curr: 0, // 当前订单前面的订单数
  }

  if (groupUnpackedParcelQtyData) {
    // 获取指定仓库地址的订单数量数组
    const qtyArr = groupUnpackedParcelQtyData[addrid]

    if (qtyArr) {
      // 计算该仓库所有订单的总数
      r.total = qtyArr.reduce((prev, curr) => calc.add(prev, curr.jyoCounter), 0)

      // 计算包裹数量小于等于当前订单的订单总数
      // 这些订单会优先打包，所以代表当前订单前面有多少单
      r.curr = qtyArr.reduce((prev, curr) => {
        if (Number(curr.jyoParcelQty) <= qty) {
          return calc.add(prev, curr.jyoCounter)
        }
        return prev
      }, 0)
    }
  }

  return r
}
